import { createReducer } from "@ngrx/store";
import { AuthState } from "./auth.models";
import * as AuthActions from "./auth.actions";
import { on } from "@ngrx/store"; 

export const initialState : AuthState = {
  data : null,
  error: null,
  message: null,
  success: false,
  validationError: []
}

export const authReducer = createReducer(
  initialState,

  on(AuthActions.RegisterSuccess, (state, payload) => ({
    ...state,
    data: payload,
    error: null,
    message: "Registration successful",
    success: true,
    validationError: []
  })),

  on(AuthActions.RegisterFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(AuthActions.VerifyOtpSuccess, (state, payload) => ({
    ...state,
    data: payload,
    error: null,
    message: "OTP verification successful", 
    success: true,
    validationError: []
  })),

  on(AuthActions.VerifyOtpFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(AuthActions.ResendOtpSuccess, (state, payload) => ({
    ...state,
    data: payload,
    error: null,
    message: "OTP resent successfully", 
    success: true,
    validationError: []
  })),

  on(AuthActions.ResendOtpFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(AuthActions.LoginSuccess, (state, payload) => ({
    ...state,
    data: payload,
    error: null,
    message: "Login successful", 
    success: true,
    validationError: []
  })),

  on(AuthActions.LoginFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(AuthActions.SsoExchangeSuccess, (state, payload) => ({
    ...state,
    data: payload,
    error: null,
    message: "SSO login successful",
    success: true,
    validationError: []
  })),

  on(AuthActions.SsoExchangeFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(AuthActions.ForgotPasswordSuccess, (state) => ({
    ...state,
    error: null,
    message: "Password reset link sent successfully", 
    success: true,
    validationError: []
  })),
  
  on(AuthActions.ForgotPasswordFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(AuthActions.ResetPasswordSuccess, (state) => ({
    ...state,
    error: null,
    message: "Password reset successful", 
    success: true,
    validationError: []
  })),
  
  on(AuthActions.ResetPasswordFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),
  
  on(AuthActions.LogoutSuccess, (state) => ({
    ...state,
    data: null,
    error: null,
    message: "Logout successful", 
    success: true,
    validationError: []
  })),

  on(AuthActions.LogoutFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(AuthActions.AuthValidationError, (state, { validationError }) => ({
    ...state,
    validationError,
    error: null,
    message: null,
    success: false
  })),
  on(AuthActions.ChangePasswordSuccess, (state) => ({
    ...state,
    error: null,
    message: "Password changed successfully", 
    success: true,
    validationError: []
  })),
  
  on(AuthActions.ChangePasswordFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(AuthActions.SetPasswordSuccess, (state) => ({
    ...state,
    error: null,
    message: "Password set successfully", 
    success: true,
    validationError: []
  })),
  
  on(AuthActions.SetPasswordFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  }))
)
